import { render, staticRenderFns } from "./IssuesCategoryItem.vue?vue&type=template&id=37aa5f16&scoped=true&"
import script from "./IssuesCategoryItem.vue?vue&type=script&lang=js&"
export * from "./IssuesCategoryItem.vue?vue&type=script&lang=js&"
import style0 from "./IssuesCategoryItem.vue?vue&type=style&index=0&id=37aa5f16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37aa5f16",
  null
  
)

export default component.exports